import {Injectable} from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import * as moment from 'moment';

import {FirebaseNotesService} from './notes.service';
import {InvoiceDB, InvoiceWithID, RentSettingsDB} from '../../interfaces/rent.interface';
import {RepairDB} from '../../interfaces/repair.interface';


@Injectable()
export class FirebaseRentService {

  constructor(private afs: AngularFirestore) {
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getInvoicesPerProperty(org_id: string, property_id: string): Observable<InvoiceWithID[]> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('invoices');

    return list.snapshotChanges().map(actions => {
      return actions.map(item => {
        const data = item.payload.doc.data() as InvoiceDB;
        const id = item.payload.doc.id;
        return {id, ...data};
      });
    });
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getInvoicesPerPropertyTenant(org_id: string, property_id: string, uid: string): Observable<InvoiceWithID[]> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('invoices', invoice =>
        invoice.where('tenant_id', '==', uid)
      );

    return list.snapshotChanges().map(actions => {
      return actions.map(item => {
        const data = item.payload.doc.data() as InvoiceDB;
        const id = item.payload.doc.id;
        return {id, ...data};
      });
    });
  }


  /**
   * Update Repair Object in DB @ [organizations > org_id > properties > property_id > repairs > repaird_id]
   * @param {string} org_id
   * @param {string} property_id
   * @param repair_id
   * @param {boolean} value
   * @returns {Observable<any>}
   */
  updateInvoicePaymentStatus(org_id: string, property_id: string, invoice_id, value: boolean) {
    const object = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('invoices').doc(invoice_id);

    const transaction = object.update({
      isPaid: value,
      paidDate: moment().toISOString()
    });

    return this.fromFirebaseAuthPromise(transaction);
  }


  /**
   * Add Invoice to DB @ [organizations > org_id > properties > property_id > invoices]
   * @param {string} org_id
   * @param {string} property_id
   * @param {any} formData
   * @returns {Observable<firebase.firestore.DocumentReference>}
   */
  addInvoiceToProperty(org_id: string, property_id: string, formData: any): Observable<any> {
    const invoiceRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('invoices');


    return this.fromFirebaseAuthPromise(invoiceRef.add(formData));
  }


  /**
   * Get Rent Payment settings to DB @ [organizations > org_id > properties > property_id > rent ]
   * @param {string} org_id
   * @param {string} property_id
   * @param {any} formData
   * @returns {Observable<firebase.firestore.DocumentReference>}
   */
  getRentPaymentSettingsAtProperty(org_id: string, property_id: string): Observable<any> {

    const updateRentSettingsRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('rent').doc('settings');

    return updateRentSettingsRef.snapshotChanges()
      .map(res => res.payload);

  }


  /**
   * Update Rent Payment settings to DB @ [organizations > org_id > properties > property_id > rent ]
   * @param {string} org_id
   * @param {string} property_id
   * @param {any} formData
   * @returns {Observable<firebase.firestore.DocumentReference>}
   */
  updateRentPaymentSettingsAtProperty(org_id: string, property_id: string, formData: any, isUpdate: boolean): Observable<any> {

    const updateRentSettingsRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('rent').doc('settings');

    if (!isUpdate) {
      return this.fromFirebaseAuthPromise(updateRentSettingsRef.set(formData));
    }
    if (isUpdate) {
      return this.fromFirebaseAuthPromise(updateRentSettingsRef.update(formData));
    }

  }


  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/rent.service.ts